// extracted by mini-css-extract-plugin
export var aiStarSpin = "_me-1";
export var spinner = "_me-0";